// helpers.
const status = ['', 'Con retraso', 'A tiempo']

// main function.
const otStatusFormat = (num) => {
  return status[num]
}

export default otStatusFormat
